export default {
  accountCreated:
    'Váš úèet byl vytvoøen. Zkontrolujte prosím svùj e-mail a postupujte podle ovìøovacího postupu. Po dokonèení budete moci svùj úèet nakonfigurovat. Pøíjemnou zábavu pøi nastavování!',
  FAILED_TO_ACTIVATE:
    'Nìco se stalo a my jsme nemohli váš úèet aktivovat. Zkontrolujte prosím svùj e-mail nebo se obrate na náš tým podpory na adrese contact@sportya.net',
  SUCCESSFULLY_ACTIVATED:
    'Gratulujeme! Váš úèet je úspìšnì aktivován. Nyní se mùžete pøihlásit a pokraèovat v nastavení úètu!',
};
